import { render, staticRenderFns } from "./AIAnswer.vue?vue&type=template&id=252815bc&scoped=true"
import script from "./AIAnswer.vue?vue&type=script&lang=js"
export * from "./AIAnswer.vue?vue&type=script&lang=js"
import style0 from "./AIAnswer.vue?vue&type=style&index=0&id=252815bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252815bc",
  null
  
)

export default component.exports